import { render, staticRenderFns } from "./SharedLinkPanel.vue?vue&type=template&id=01b9d642&"
import script from "./SharedLinkPanel.vue?vue&type=script&lang=js&"
export * from "./SharedLinkPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports